import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Import VueToast and its styles
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

// Create the Vue app instance with router and store
const app = createApp(App);
app.use(router);
app.use(store);

// Use VueToast with your desired configuration
app.use(VueToast, {
    position: 'top-right', // You can change the position as needed
});

// Mount the app to the element with id "app"
app.mount('#app');
